// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import ar from './ar';
import de from './de';
import en from './en-us/index';
import es from './es/index';
import fr from './fr';
import it from './it';
import ja from './ja/index';
import ko from './ko';
import ru from './ru';
import zh_Hans from './zh-Hans/index';
import zh_Hant from './zh-Hant/index';

export const resources = {
  'en-US': {
    translation: en,
  },
  'zh-Hans': {
    translation: zh_Hans,
  },
  'zh-Hant': {
    translation: zh_Hant,
  },
  es: {
    translation: es,
  },
  ja: {
    translation: ja,
  },
  de: {
    translation: de,
  },
  fr: {
    translation: fr,
  },
  ru: {
    translation: ru,
  },
  it: {
    translation: it,
  },
  ar: {
    translation: ar,
  },
  ko: {
    translation: ko,
  },
};
